import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function IconDelete({
  className,
  width,
  height,
  id,
  color,
  hoverColor,
  viewBox,
  onClick,
}) {
  const [mainColor, setMainColor] = useState(color);

  useEffect(() => {
    if (color !== mainColor) {
      setMainColor(color);
    }
  }, [color]);

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox={viewBox}
      onMouseEnter={() => setMainColor(hoverColor)}
      onMouseLeave={() => setMainColor(color)}
      onClick={onClick}
    >
      <defs>
        <path
          id="icon-delete"
          d="M11.4 2.45a2.4 2.4 0 012.394 2.236l.006.164-.001.6H16.2a.8.8 0 01.794.7l.006.1a.8.8 0 01-.7.794l-.1.006h-.9v8.1a2.4 2.4 0 01-2.236 2.394l-.164.006H7.1a2.4 2.4 0 01-2.394-2.236L4.7 15.15v-8.1h-.9a.8.8 0 01-.794-.7L3 6.25a.8.8 0 01.7-.794l.1-.006h2.399l.001-.6a2.4 2.4 0 012.236-2.394L8.6 2.45h2.8zm2.3 4.6H6.3v8.1a.8.8 0 00.7.794l.1.006h5.8a.8.8 0 00.794-.7l.006-.1v-8.1zm-5.2 1.9a.8.8 0 01.794.7l.006.1v3.5a.8.8 0 01-1.594.1l-.006-.1v-3.5a.8.8 0 01.8-.8zm3 0a.8.8 0 01.8.8v3.5a.8.8 0 11-1.6 0v-3.5a.8.8 0 01.8-.8zm-.1-4.9H8.6a.8.8 0 00-.794.7l-.006.1-.001.6h4.4l.001-.6a.8.8 0 00-.7-.794l-.1-.006z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id={id} fill="#FFF">
          <use xlinkHref="#icon-delete" />
        </mask>
        <g fill={mainColor} mask={`url(#${id})`}>
          <path d="M0 0H20V20H0z" />
        </g>
      </g>
    </svg>
  );
}

IconDelete.defaultProps = {
  onClick: () => {},
  className: undefined,
  width: 20,
  height: 20,
  color: '#BDBDBD',
  hoverColor: '#fff',
  viewBox: '0,0,20,20',
};

IconDelete.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  id: PropTypes.string.isRequired,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  viewBox: PropTypes.string,
};

export default IconDelete;
